import './index.scss';

class BackToTop {
    constructor(root) {
        this.root = root;

        this.scroll();
        window.addEventListener('scroll', this.scroll.bind(this));

        this.root.addEventListener('click', (event) => {
            event.stopImmediatePropagation();
            event.preventDefault();

            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        });
    }

    scroll() {
        if (window.scrollY > window.innerHeight) {
            this.root.classList.add('shown');
        } else {
            this.root.classList.remove('shown');
        }
    }
}

window.app.run(() => {
    document.querySelectorAll('.back-to-top').forEach((node) => {
        new BackToTop(node);
    });
});
